import { render } from "./navbar.vue?vue&type=template&id=680ca266&scoped=true&ts=true"
import script from "./navbar.vue?vue&type=script&lang=ts"
export * from "./navbar.vue?vue&type=script&lang=ts"

import "./navbar.vue?vue&type=style&index=0&id=680ca266&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-680ca266"]])

export default __exports__